export { default as ProductDetail } from './product-detail';
